import React from "react";

const FaqThree = () => {
  return (
    <section className='d-flex overflow-hidden position-relative overflow-hidden'>
      <img
        src='assets/images/shapes/shape1.png'
        alt=''
        className='animation-rotation flex-shrink-0 position-absolute inset-block-end-25-percent inset-inline-start-34-percent z-n1'
      />
      <img
        src='assets/images/shapes/shape5.png'
        alt=''
        className='animation-walking flex-shrink-0 position-absolute inset-inline-start-10-persent inset-block-start-30-persent z-n1'
      />
      <img
        src='assets/images/shapes/shape3.png'
        alt=''
        className='animation-walking flex-shrink-0 position-absolute inset-inline-end-13-persent inset-block-start-10-persent z-n1'
      />
      <img
        src='../../assets/images/shapes/curve-arrow.png'
        alt=''
        className='animate__wobble__two flex-shrink-0 position-absolute inset-block-end-8-persent inset-inline-end-8-persent z-n1'
      />
      <div className='container'>
        <div className='row align-items-center'>
          <div
            className='col-lg-6 wow bounceIn flex-shrink-0'
            data-wow-duration='3s'
          >
            <img
              src='assets/images/thumbs/faq.png'
              alt='Vibe research FAQ - Research Solution'
              className=''
            />
          </div>
          <div className='col-lg-6'>
            <div className='py-120 max-w-526-px lg-ms-134px'>
              <div className='faq-content'>
                <div className='mb-40'>
                  <div className='flex-align d-inline-flex flex-wrap gap-8 mb-16 wow bounceInDown'>
                    <span className='text-main-600 text-2xl d-flex'>
                      <i className='ph-bold ph-question' />
                    </span>
                    <h5 className='text-main-600 mb-0'>
                      Pertanyaan Yang Sering Diajukan
                    </h5>
                  </div>
                  <h2 className='mb-24 wow bounceIn'>
                    Informasi Lengkap Layanan Vibe Research Solution
                  </h2>
                  <p className='text-neutral-500 text-line-2 wow bounceInUp'>
                    Temukan jawaban untuk pertanyaan umum seputar layanan konsultasi penelitian akademik kami.
                  </p>
                </div>
                <div className='accordion common-accordion' id='accordionExample'>
                  <div className='accordion-item' data-aos='fade-up-left' data-aos-duration={400}>
                    <h2 className='accordion-header'>
                      <button className='accordion-button' type='button' data-bs-toggle='collapse' data-bs-target='#collapseOne'>
                        Bagaimana proses konsultasi penelitian di Vibe Research Solution?
                      </button>
                    </h2>
                    <div id='collapseOne' className='accordion-collapse collapse show' data-bs-parent='#accordionExample'>
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Konsultasi dapat dilakukan melalui WhatsApp atau email. Tim kami akan menganalisis kebutuhan penelitian Anda, memberikan penawaran layanan yang sesuai, dan menyusun timeline pengerjaan yang disepakati bersama.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='accordion-item' data-aos='fade-up-left' data-aos-duration={600}>
                    <h2 className='accordion-header'>
                      <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#collapseTwo'>
                        Berapa lama waktu yang dibutuhkan untuk pengerjaan jurnal?
                      </button>
                    </h2>
                    <div id='collapseTwo' className='accordion-collapse collapse' data-bs-parent='#accordionExample'>
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Waktu pengerjaan bervariasi tergantung pada jenis jurnal dan kompleksitas penelitian. Untuk jurnal SINTA umumnya membutuhkan waktu 1-2 bulan, sedangkan jurnal internasional (Scopus/WoS) memerlukan 2-3 bulan.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='accordion-item' data-aos='fade-up-left' data-aos-duration={800}>
                    <h2 className='accordion-header'>
                      <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#collapseThree'>
                        Apakah Vibe Research Solution menjamin kerahasiaan data penelitian?
                      </button>
                    </h2>
                    <div id='collapseThree' className='accordion-collapse collapse' data-bs-parent='#accordionExample'>
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Ya, kami menjamin kerahasiaan semua data dan informasi penelitian klien. Kami menandatangani perjanjian kerahasiaan (NDA) dan menggunakan sistem penyimpanan data yang aman.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='accordion-item' data-aos='fade-up-left' data-aos-duration={1000}>
                    <h2 className='accordion-header'>
                      <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#collapseFour'>
                        Apa saja layanan konsultasi yang tersedia?
                      </button>
                    </h2>
                    <div id='collapseFour' className='accordion-collapse collapse' data-bs-parent='#accordionExample'>
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Kami menyediakan layanan penulisan jurnal nasional dan internasional, pengerjaan skripsi/tesis/disertasi, konsultasi metodologi penelitian, dan pengambilan data penelitian dalam dan luar negeri.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className='accordion-item' data-aos='fade-up-left' data-aos-duration={1200}>
                    <h2 className='accordion-header'>
                      <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#collapseFive'>
                        Bagaimana dengan kualitas dan originalitas penelitian?
                      </button>
                    </h2>
                    <div id='collapseFive' className='accordion-collapse collapse' data-bs-parent='#accordionExample'>
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Setiap karya ilmiah yang kami kerjakan dijamin originalitasnya dan bebas plagiarisme. Kami menggunakan software anti-plagiarisme dan melakukan review berkala untuk memastikan kualitas tertinggi.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqThree;
